import { createContext } from 'react';
export var MenuContext = createContext({
    searchTerm: '',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    addOption: function () { },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setClickHandlerForOption: function () { },
});
//# sourceMappingURL=MenuContext.js.map